import { INewConversationMessage } from "../../types/webchatConversation";
import {
  DISCONNECT_SOCKET,
  SOCKET_INITALIZED,
  START_CONVERSATION,
  START_SOCKET,
  WRITE_MESSAGE,
} from "./constants";

export const startSocket = () => ({
  type: START_SOCKET,
});

export const socketInitialized = () => ({
  type: SOCKET_INITALIZED,
});

export const writeMessage = (message: INewConversationMessage) => ({
  type: WRITE_MESSAGE,
  payload: { message },
});

export const startConversation = () => ({
  type: START_CONVERSATION,
});
export const disconnectSocket = () => ({
  type: DISCONNECT_SOCKET,
});
